<template>
  <Dialog
    v-model:visible="visibleDialog"
    :style="{ width: '700px' }"
    :header="project.path"
    :modal="true"
    @hide="hideDialog"
  >
    <Toolbar class="p-mb-4">
      <template #start>
        <Button
          label="Novo"
          icon="pi pi-plus"
          class="mr-2"
          @click="showCreateFolder()"
        />
      </template>
      <template #end>
        <div
          class="table-header p-d-flex p-flex-column p-flex-md-row p-jc-md-between"
        >
          <span class="p-input-icon-left">
            <i class="pi pi-search" />
            <InputText
              v-model="filters['global'].value"
              placeholder="Buscar..."
            />
          </span>
        </div>
      </template>
    </Toolbar>
    <DataTable
      ref="dt1"
      dataKey="id"
      class="p-datatable-sm"
      :value="folders"
      :paginator="true"
      :rows="5"
      :rowsPerPageOptions="[5, 10, 15]"
      :filters="filters"
      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      currentPageReportTemplate="Exibindo de {first} a {last} no total de {totalRecords} diretórios."
    >
      <template #empty>
        <div class="text-center">Nenhum resultado encontrado...</div>
      </template>
      <Column header="Caminho" field="subDirectory" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.project.path }}/{{ slotProps.data.subDirectory }}
        </template>
      </Column>
      <Column
        header="Descrição do Caminho"
        field="description"
        :sortable="true"
      >
        <template #body="slotProps">
          {{ slotProps.data.description }}
        </template>
      </Column>
      <Column header="Ações">
        <template #body="slotProps">
          <Button
            icon="pi pi-code"
            class="p-button-rounded mr-2"
            @click="showConfig(slotProps.data)"
            v-tooltip.top="'CONFIGURAÇÕES DE DESENVOLVIMENTO'"
          />
          <Button
            icon="pi pi-pencil"
            class="p-button-rounded p-button-success mr-2"
            @click="showUpdateFolder(slotProps.data)"
            v-tooltip.top="'CLIQUE PARA EDITAR'"
          />
          <Button
            icon="pi pi-trash"
            class="p-button-rounded p-button-warning"
            @click="showRemoveFolder(slotProps.data)"
            v-tooltip.top="'CLIQUE PARA EXCLUIR'"
          />
        </template>
      </Column>
    </DataTable>
  </Dialog>

  <!--MODAL FORM-FOLDERS -->
  <dialog-form
    :selected="folder"
    @findAll="findfoldersByProjectId(this.project.id)"
  />
  <dialog-config :selected="folder" />
  <!--MODAL FORM-FOLDERS -->
</template>
<script>
import { FilterMatchMode } from "primevue/api";

//Models
import Project from "../../models/project";
import Folder from "../../models/folder";

//Services
import ProjectService from "../../service/project/project_service";
import FolderService from "../../service/folder/folder_service";

//Dialogs
import DialogForm from "./components/dialog-form.vue";
import DialogConfig from "./components/dialog-config.vue";

export default {
  components: {
    DialogForm,
    DialogConfig,
  },
  props: ["selectedProject"],
  data() {
    return {
      project: new Project(),
      projectService: new ProjectService(),
      folder: new Folder(),
      folderService: new FolderService(),
      folders: [],
      submitted: false,
      filters: {},
    };
  },
  created() {
    this.initFilters();
  },
  computed: {
    visibleDialog: {
      get() {
        let value = this.$store.state.views.folder.dialogList;
        if (value === true) this.getData();
        return value;
      },
      set(value) {
        this.$store.state.views.folder.dialogList = value;
      },
    },
  },
  methods: {
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
    showConfig(folder) {
      this.folder = folder;
      this.$store.state.views.folder.dialogConfig = true;
    },
    showCreateFolder() {
      this.folder = new Folder();
      this.folder.project = this.project;
      this.$store.state.views.folder.dialogForm = true;
    },
    showUpdateFolder(folder) {
      this.folder = { ...folder };
      this.$store.state.views.folder.dialogForm = true;
    },
    showRemoveFolder(folder) {
      this.folder = { ...folder };
      this.$confirm.require({
        message:
          "Deseja realmente excluir esse diretório(" +
          folder.subDirectory +
          ")?",
        header: "Deseja excluir esse diretório?",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sim",
        rejectLabel: "Não",
        accept: () => {
          this.folderService
            .delete(this.folder.id)
            .then((data) => {
              this.$msgSuccess(data);
              this.findfoldersByProjectId(this.project.id);
            })
            .catch((err) => {
              this.$msgErro(err);
            });
        },
      });
    },
    hideDialog() {
      this.project = new Project();
      this.submitted = false;
      this.visibleDialog = false;
    },
    getData() {
      this.project = this.selectedProject;
      this.findfoldersByProjectId(this.project.id);
    },
    findfoldersByProjectId(projectId) {
      this.folderService
        .findfoldersByProjectId(projectId)
        .then((data) => {
          this.folders = data;
        })
        .catch((error) => {
          this.$msgErro(error);
        });
    },
  },
};
</script>
<style scoped></style>
